import { fetcher } from '@/services/graphql/fetcher/index';
import { CustomComponentType, CustomPageType, Sort, type AnyObj } from '@/types';
import {
  fetchBoundDistributorDocument,
  fetchCustomPageDocument,
  fetchDesDeCodeDocument,
  fetchDistributorSharingDocument,
  fetchGetAnnouncementDocument,
  fetchGetDistributorDocument,
  fetchOrderTrackingDocument,
  fetchSeriesProductsDocument,
} from '../graphql/docs';
import { LIMIT } from '@/constants';

/**
 * 获取自定义页面数据
 * @param type - 自定义页面类型
 */
export const fetchCustomData = async (
  type: CustomPageType,
  customPageId: string = '',
  isPreview: boolean = false
) => {
  const res = await fetcher.query(fetchCustomPageDocument, {
    variables: {
      customPageId,
      isPreview,
      options: {
        filter: {
          type: { eq: type },
          enable: { eq: true },
        },
      },
    },
  });
  const data = res.data.value?.customPage;
  if (data) {
    // 取商品组件类型的第一个，即只渲染一个商品分类组件
    const index = data.components.findIndex(
      (it: AnyObj) => it.type === CustomComponentType.product
    );
    if (index >= 0) {
      data.components[index]._render = true;
    }
    return data;
  }
};

/**
 * 获取活动页面数据
 * @param type - 自定义页面类型
 */
export const fetchActivityCustomData = async (customPageId: string, isPreview: boolean = false) => {
  const res = await fetcher.query(fetchCustomPageDocument, {
    variables: {
      customPageId,
      isPreview,
      // options: {
      //   filter: {
      //     enable: { eq: true },
      //   },
      // },
    },
  });
  const data = res.data.value?.customPage;
  if (data) {
    // 取商品组件类型的第一个，即只渲染一个商品分类组件
    const index = data.components.findIndex(
      (it: AnyObj) => it.type === CustomComponentType.product
    );
    if (index >= 0) {
      data.components[index]._render = true;
    }
    return data;
  }
};

/**
 * 根据分类id获取商品数据
 * @param collectionId - 分类id
 * @returns
 */
export const fetchSeriesProductsByCollectionId = async (collectionId: string) => {
  const res = await fetcher.query(fetchSeriesProductsDocument, {
    variables: {
      collectionId,
      options: {
        filter: {
          hidden: { eq: false },
          freeGift: { eq: false },
        },
        sort: { id: Sort.ASC, createdAt: Sort.DESC },
      },
    },
  });
  return res.data.value?.seriesProducts?.items;
};

/**
 * 根据分类id获取商品数据
 * @param collectionId - 分类id
 * @returns
 */
export const fetchSeriesProductsByCollection = async (variables: AnyObject) => {
  const res = await fetcher.query(fetchSeriesProductsDocument, {
    variables: {
      collectionId: variables.collectionId,
      options: {
        skip: LIMIT * variables.options.skip,
        take: variables.options?.take || LIMIT,
        filter: {
          hidden: { eq: false },
          freeGift: { eq: false },
          name: { contains: variables.options?.name },
        },
        sort: { id: Sort.ASC, createdAt: Sort.DESC },
      },
    },
  });
  return res.data.value?.seriesProducts;
};

/**
 * 查询自己的分销员信息
 */
export const fetchGetDistributor = async () => {
  const res = await fetcher.query(fetchGetDistributorDocument, {});
  return res.data.value?.getDistributor;
};

/**
 * 根据类型获取分享信息
 * @param input - {type, path}
 * @returns
 */
export const fetchDistributorSharing = async (input: AnyObj) => {
  const res = await fetcher.query(fetchDistributorSharingDocument, {
    variables: {
      input,
    },
  });
  return res.data.value?.distributorSharing;
};

/**
 * 绑定分销员
 * @param distributorId - 分销id
 * @returns
 */
export const fetchBoundDistributor = async (distributorId: string) => {
  const res = await fetcher.mutation(fetchBoundDistributorDocument, {
    distributorId,
  });
  return res.data?.boundDistributor;
};

/**
 * 获取通告信息
 */
export const fetchGetAnnouncement = async () => {
  const res = await fetcher.query(fetchGetAnnouncementDocument, {
    variables: {},
  });
  return res.data.value?.getAnnouncement;
};

/**
 * 引导页面用户下单上报数据
 */
export const fetchOrderTracking = async (
  orderId: string,
  trackingPageType: string,
  trackingPageId: string
) => {
  const res = await fetcher.mutation(fetchOrderTrackingDocument, {
    orderId,
    trackingPageType,
    trackingPageId,
  });

  return res.data.value?.addOrderTracking;
};

// 解析code
export const fetchDesCode = async (input: string) => {
  const res = await fetcher.query(fetchDesDeCodeDocument, {
    variables: {
      input,
    },
  });
  return res.data.value?.desDecode;
};
